// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__wk8AO","insightsList":"newBusinessInsightsMenu_insightsList__2iBPh","active":"newBusinessInsightsMenu_active__akUkA"};